import { BrandingClient } from '@frontend/account/api';
import { EntityType } from '@frontend/common';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useBranding:request': CustomEvent<string>;
    }
}

const REQUEST_BRANDING_EVENT = 'useBranding:request';
const STORAGE_KEY = 'BRND_REQ';

export function brandingRequest(brandingId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_BRANDING_EVENT, { detail: brandingId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function BrandingResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_BRANDING_EVENT, EntityType.BRANDING, (ids) => BrandingClient.resolveBrandings(ids), props.dispatch);
    return <></>;
}